import { render, staticRenderFns } from "./buscarAtendimento.vue?vue&type=template&id=2793bc41"
import script from "./buscarAtendimento.ts?vue&type=script&lang=js&external"
export * from "./buscarAtendimento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2793bc41')) {
      api.createRecord('2793bc41', component.options)
    } else {
      api.reload('2793bc41', component.options)
    }
    module.hot.accept("./buscarAtendimento.vue?vue&type=template&id=2793bc41", function () {
      api.rerender('2793bc41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/atendimentos/buscarAtendimento/buscarAtendimento.vue"
export default component.exports